import {Room, RoomJoin, RoomJoins, Rooms} from "./types";
import React from "react";
import {StyledBoxColumn, StyledBoxRow} from "shared/StyledComponents";
import {PD_LG, PD_MD, PD_XLG2} from "shared/dimens";
import {ListItemChange, OnListItemsListener} from "shared/types";
import {COLOR_BG2} from "./App";
import {BaseFragment, BaseFragmentProps, BaseFragmentState} from "shared/BaseFragment";
import {CreateOrJoinPage} from "./Components";
import {Button, Typography} from "@mui/material";
import {ChevronRightOutlined} from "@mui/icons-material";

export type GamesFragmentProps = BaseFragmentProps & {}

type GamesFragmentState = BaseFragmentState & {
  rooms: Room[],
}

const HOW_TO_PLAY = "### _How to play_:" +
  "&nbsp;&nbsp;\n" +
  "1. Enter a Nickname and click on the NEW GAME button." +
  "&nbsp;&nbsp;\n" +
  "1. Select the preferred game settings and start the game." +
  "&nbsp;&nbsp;\n" +
  "1. If playing with friend, connect with them using your favorite audio or video chat." +
  "&nbsp;&nbsp;\n" +
  "1. Share the room URL with your friend." +
  "&nbsp;&nbsp;\n" +
  "1. Enjoy the game!";


export class GamesFragment extends BaseFragment<GamesFragmentProps, GamesFragmentState> implements OnListItemsListener<RoomJoin> {

  private readonly loader = RoomJoins.getInstance();

  protected async fetchOnMount(forceReload?: boolean): Promise<void> {
    if (forceReload) {
      await this.loader.loadListItems();
    } else {
      await this.loader.maybeLoadListItems();
    }
    const rooms: Room[] = [];
    for (const join of this.loader.getListItems()) {
      const room = await Rooms.getInstance().getOrLoadItem(join.id);
      if (room) {
        rooms.push(room);
      }
    }
    this.setState({
      rooms: rooms,
    });
  }

  componentDidMount() {
    super.componentDidMount();
    RoomJoins.getInstance().registerObserver(this);
  }

  componentWillUnmount() {
    RoomJoins.getInstance().unregisterObserver(this);
    super.componentWillUnmount();
  }

  onItemChanged(item: RoomJoin, change: ListItemChange) {
    this.reload(true);
  }

  protected renderContainerContent(): React.ReactElement | null {
    return <div style={{display: "flex", flexDirection: "column"}}>
      <div style={{display: "flex", flexDirection: "column", height: "100vh"}}>
        <StyledBoxRow style={{
          width: "100%",
          zIndex: 1,
          maxHeight: 96,
          boxSizing: "border-box",
          justifyContent: "center",
          background: COLOR_BG2,
        }}>
          <img src={"/images/logotype.svg"} style={{width: "100%", filter: "invert(1)", opacity: 0.2}}/>
        </StyledBoxRow>
        <StyledBoxColumn style={{flexGrow: 1, alignItems: "center", justifyContent: "center", marginTop: -96}}>
          <CreateOrJoinPage path={this.props.path} text={HOW_TO_PLAY}
                            title={"Play chess with only a link, no login required."}/>
          {this.state.rooms?.length > 0
            ? <StyledBoxColumn style={{boxSizing: "border-box", padding: PD_MD, gap: 4, width: "100%", maxWidth: 480}}>
              <Typography
                style={{color: "#ccc", fontWeight: "bold", textAlign: "center", padding: PD_LG}}>
                Ongoing games
              </Typography>
              {this.state.rooms.map(item => <Button
                variant="outlined"
                endIcon={<ChevronRightOutlined/>}
                onClick={() => this.props.path.navigate("/" + item.id)}>
                <StyledBoxRow style={{width: "100%"}}>
                  <Typography>{item.id}</Typography>
                </StyledBoxRow>
              </Button>)}
            </StyledBoxColumn>
            : null}
        </StyledBoxColumn>
      </div>
      <div style={{position: "relative", width: "100%", aspectRatio: 3 / 2}}>
        <img src={"/images/hero1.png"}
             style={{position: "absolute", width: "100%", height: "100%", objectFit: "cover"}}/>
        <div style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1))"
        }}/>
      </div>
      <StyledBoxColumn style={{background: "#000", color: "white", alignItems: "center", padding: PD_XLG2}}>
        <a href={"https://fyne.studio"} target="_blank">
          <img src={"/images/fynestudio.png"} style={{
            width: 128,
            filter: "grayscale(1) brightness(10)",
            opacity: 0.7
          }}/></a>
        <Typography variant="body2" style={{textAlign: "center"}}>
          {`Copyright © ${new Date().getFullYear()} Superfyne LLC. All rights reserved.`}
        </Typography>
      </StyledBoxColumn>
    </div>;
  }
}